import Component from '@glimmer/component';
import Text from './text';

interface MatchScoreBadgeSignature {
  Args: {
    /** Match score value (0-100) */
    score: number | undefined;
    /** Optional label below the badge */
    label?: string;
    /** Badge size */
    size?: 'sm' | 'md' | 'lg';
    /** Optional custom function to derive score class */
    getClass?: (score: number) => string;
  };
  Element: HTMLDivElement;
}

// Use odd pixel widths (w-[39px], w-[55px], w-[79px]) for proper centering on even-width borders/rings
// See typescript.instructions.md "Centering Elements" for explanation
export default class MatchScoreBadge extends Component<MatchScoreBadgeSignature> {
  get score() {
    return this.args.score ?? 0;
  }

  get sizeClass() {
    switch (this.args.size) {
      case 'sm':
        return 'w-[39px] h-[39px] text-xs';
      case 'lg':
        return 'w-[79px] h-[79px] text-xl';
      default:
        return 'w-[55px] h-[55px] text-sm';
    }
  }

  get scoreClass() {
    if (this.args.getClass) {
      return this.args.getClass(this.score);
    }
    if (this.score >= 90) {
      return 'tio-match-score--excellent tio-bg-success-soft tio-fg-success-body';
    }
    if (this.score >= 80) return 'tio-bg-success-soft tio-fg-success-body';
    if (this.score >= 70) return 'tio-bg-warning-soft tio-fg-warning-body';
    return 'tio-bg-sunken tio-fg-secondary';
  }

  <template>
    <div class="text-center" ...attributes>
      <div class="rounded-full tio-row-center font-bold {{this.sizeClass}} {{this.scoreClass}}">
        {{this.score}}%
      </div>
      {{#if @label}}
        <Text @variant="muted" @size="xs" class="mt-1">{{@label}}</Text>
      {{/if}}
    </div>
  </template>
}
